import { clamp } from './util';

/** Log wavelength axis shared by the band strip and the signature plot. */
export const NM_LO = 400;
export const NM_HI = 2400;
export const axPos = (nm: number): number =>
  (Math.log(nm) - Math.log(NM_LO)) / (Math.log(NM_HI) - Math.log(NM_LO));

/**
 * Approximate sRGB for a visible wavelength. Beyond 780nm there is no real colour,
 * so a conventional dark-red to slate ramp stands in — deliberately unconvincing,
 * because infrared should not look like something you could see.
 */
export function wavelengthRGB(nm: number): [number, number, number] {
  if (nm >= 780) {
    const t = clamp((Math.log(nm) - Math.log(780)) / (Math.log(2400) - Math.log(780)), 0, 1);
    return [Math.round(96 - 56 * t), Math.round(26 + 22 * t), Math.round(26 + 30 * t)];
  }
  let r = 0, g = 0, b = 0;
  if (nm < 440) { r = -(nm - 440) / 60; b = 1; }
  else if (nm < 490) { g = (nm - 440) / 50; b = 1; }
  else if (nm < 510) { g = 1; b = -(nm - 510) / 20; }
  else if (nm < 580) { r = (nm - 510) / 70; g = 1; }
  else if (nm < 645) { r = 1; g = -(nm - 645) / 65; }
  else { r = 1; }
  let f = 1;
  if (nm < 420) f = 0.3 + 0.7 * (nm - 380) / 40;
  else if (nm > 700) f = 0.3 + 0.7 * (780 - nm) / 80;
  const ch = (x: number) => Math.round(255 * Math.pow(clamp(x * f, 0, 1), 0.8));
  return [ch(r), ch(g), ch(b)];
}
